import { useRouter } from "next/router";

export default function useAppRouter() {
    const router = useRouter();
    const query = router.query;
    const slug = router.query.slug;


    

    return;
}
